module.exports = __webpack_public_path__ + "0f4da24f6a8efa25fd4e0305168a5129.png";